// extracted by mini-css-extract-plugin
export default {"wrapper":"NotFound_wrapper__woiKt","notFound":"NotFound_notFound__BEDid","link":"NotFound_link__k4nv4","link__arrow":"NotFound_link__arrow__nDHcK","logo":"NotFound_logo__6ybEn"};